import React from 'react';
import { FaFacebook, FaInstagram, FaLinkedin, FaYoutube } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  return (
    <footer>
      <div className="footerContainer">
        <div className="socialIcons">
          <h3> Follow us on</h3>
          <a href="https://www.facebook.com/p/Suffah-Techno-HIGH-School-100070475036951/" target="_blank" rel="noopener noreferrer" className="socialIcon">
            <FaFacebook size={30} />
          </a>
          <a href="https://www.youtube.com/@suffahhighschool5532" target="_blank" rel="noopener noreferrer" className="socialIcon">
            <FaYoutube size={30} />
          </a>
          <a href="https://www.instagram.com/suffah_high_school/" target="_blank" rel="noopener noreferrer" className="socialIcon">
            <FaInstagram size={30} />
          </a>
          <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="socialIcon">
            <FaLinkedin size={30} />
          </a>
        </div>
      </div>
      <div className="footerBottom">
        &copy; {new Date().getFullYear()} Your Company. All Rights Reserved. <br />
        Designed and Developed by Mohammed Atif Sayeed
      </div>
    </footer>
  );
}

export default Footer;
